"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var ThumbUpFill = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M4.5 12.1a2.7 2.7 0 01.8-1.9l2.9-2.9a8 8 0 001.9-3c0-.689.353-1.28 1.1-1.3a1.2 1.2 0 011.2 1.2 7.7 7.7 0 01-.8 3.4l-.2.4c-.07.042.379.038 1.727.025.076 0 .155 0 .236-.002A2.246 2.246 0 0013.835 11 2.246 2.246 0 0013 12.75c0 .707.326 1.338.836 1.75A2.246 2.246 0 0013 16.25c0 .707.326 1.337.836 1.75a2.246 2.246 0 00-.457 3H7.593a3.199 3.199 0 01-1.422-.356h-.002A3.1 3.1 0 014.5 17.9v-5.304c.001-.177.017-.353.047-.525L4.5 12.1zm13.104 8.85a1.25 1.25 0 00-.354-2.45h-2a1.25 1.25 0 100 2.5h2c.123 0 .241-.018.354-.05zm.646-3.45a1.25 1.25 0 100-2.5h-3a1.25 1.25 0 100 2.5h3zm0-3.5a1.25 1.25 0 00.008-2.5H15.25a1.25 1.25 0 100 2.5h3zm.077-3.502A1.25 1.25 0 0018.262 8H15.25a1.263 1.263 0 00-.16.01 1.25 1.25 0 00.16 2.49h3c.026 0 .052 0 .077-.002z", fillRule: "evenodd" })));
};
ThumbUpFill.displayName = 'ThumbUpFill';
exports.default = ThumbUpFill;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ThumbUpFill.js.map